import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Cargá a todos los técnicos que participan en las intervenciones de mantenimiento.',
    'El nombre del mecánico aparece en las planillas de OTC y en los registros de mantenimiento.',
    'cada mecánico vinculado a un usuario con rol mecánico, tendrá acceso al portal de gestión de reparaciones y mantenimientos que se le asignen.',
  ],
  nextSteps: [
    'Al registrar órdenes de trabajo (OTC), asignarás los mecánicos participantes.',
    'El costo hora de cada mecánico es utilizado en planillas e informes, solo visible para usuarios con permisos.',
  ],
};

const ConfiguracionMecanicos = () => (
  <ConfiguracionBase
    apiEndpoint="mecanicos"
    titulo="Mecánicos"
    descripcion="Personal técnico del taller"
    icon="fas fa-user-cog"
    compact
    help={HELP}
  />
);

export default ConfiguracionMecanicos;
